import React, { useEffect } from 'react';
import { useGetProductAnalyticsConfigQuery } from 'lib.store/src/main/product-analytics/productAnalytics.api';
import { initAnalytics } from './client';

/**
 * Boots product analytics once per app load from the backend-served config.
 * Mounted high in the tree so every surface — public or authenticated — can
 * instrument itself without each one repeating the boot.
 */
const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data } = useGetProductAnalyticsConfigQuery();
  const config = data?.data;

  useEffect(() => {
    if (config) {
      void initAnalytics(config);
    }
  }, [config]);

  return <>{children}</>;
};

export default AnalyticsProvider;
